// extracted by mini-css-extract-plugin
export default {"Main":"App_Main__lEdFc","App":"App_App__if4Nu","Title":"App_Title__atxyx"};